// src/pages/Legal/MentionsLegales.js
import { Link } from 'react-router-dom';
import './LegalPages.css';

import { useDocumentTitle } from '../../hooks/useDocumentTitle';
export default function MentionsLegales() {
  useDocumentTitle('Mentions légales');

  return (
    <div className="legal-page">
      <div className="container legal-page__inner">
        <p className="legal-page__overtitle">Informations juridiques</p>
        <h1 className="legal-page__titre">Mentions légales</h1>
        <hr className="divider-or" style={{ margin: '16px 0 40px' }} />

        <section className="legal-section">
          <h2>1. Éditeur du site</h2>
          <p>Le site <strong>lesbazarsdekeassa.com</strong> est édité par :</p>
          <ul>
            <li><strong>Raison sociale :</strong> Les Bazars de Keassa (KEASSA)</li>
            <li><strong>Statut :</strong> Micro-entreprise</li>
            <li><strong>Siège social :</strong> Paris, France</li>
            <li><strong>Responsable de la publication :</strong> Propriétaire de KEASSA</li>
            <li><strong>Email :</strong> contact@lesbazarsdekeassa.com</li>
            <li><strong>Téléphone :</strong> +33 7 XX XX XX XX</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>2. Hébergement</h2>
          <p>L’hébergement du site repose sur deux prestataires distincts :</p>
          <p><strong>Pages du site</strong></p>
          <ul>
            <li><strong>Hébergeur :</strong> LWS (Ligne Web Services)</li>
            <li><strong>Adresse :</strong> 10 rue de Penthièvre, 75008 Paris, France</li>
            <li><strong>Site web :</strong> www.lws.fr</li>
            <li><strong>Téléphone :</strong> 01 77 62 30 03</li>
          </ul>
          <p><strong>Application et base de données</strong></p>
          <ul>
            <li><strong>Hébergeur :</strong> PythonAnywhere LLP</li>
            <li><strong>Adresse :</strong> Wenlock Road, Londres N1 7GU, Royaume-Uni</li>
            <li><strong>Site web :</strong> www.pythonanywhere.com</li>
            <li><strong>Localisation des serveurs :</strong> États-Unis</li>
          </ul>
          <p>
            C’est ce second prestataire qui héberge les données de compte et de commande.
            Les conséquences de cette localisation sont détaillées dans la{' '}
            <Link to="/politique-confidentialite">politique de confidentialité</Link>.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Propriété intellectuelle</h2>
          <p>
            L’ensemble du contenu du site lesbazarsdekeassa.com (textes, images, logos, graphismes,
            icônes, photographies, vidéos) est protégé par les lois françaises et internationales
            relatives à la propriété intellectuelle. Toute reproduction, représentation, modification,
            publication ou adaptation de tout ou partie des éléments du site est interdite sans
            l’autorisation écrite préalable de KEASSA.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Données personnelles et RGPD</h2>
          <p>
            Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
            Informatique et Libertés du 6 janvier 1978 modifiée, vous disposez d’un droit d’accès,
            de rectification, de suppression et de portabilité de vos données personnelles.
          </p>
          <p>
            Pour exercer ces droits ou pour toute question relative à vos données personnelles,
            vous pouvez nous contacter à l’adresse : <strong>contact@lesbazarsdekeassa.com</strong>
          </p>
          <p>
            Pour plus de détails, consultez notre <a href="/politique-confidentialite">Politique de confidentialité</a>.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Cookies</h2>
          <p>
            Le site n’installe aucun traceur publicitaire ni outil de mesure d’audience. Seules
            des informations strictement nécessaires à son fonctionnement sont conservées dans
            votre navigateur : session de connexion, panier et préférences de confidentialité.
            Vous pouvez consulter et modifier vos choix à tout moment via le lien
            « Gérer mes préférences » en bas de page.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Limitation de responsabilité</h2>
          <p>
            KEASSA s’efforce d’assurer l’exactitude des informations diffusées sur le site.
            Toutefois, elle ne saurait être tenue responsable des omissions, inexactitudes ou
            carences dans la mise à jour de ces informations. KEASSA se réserve le droit de
            modifier le contenu du site à tout moment et sans préavis.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Droit applicable</h2>
          <p>
            Les présentes mentions légales sont soumises au droit français. En cas de litige,
            les tribunaux français seront seuls compétents.
          </p>
        </section>

        <p className="legal-page__update">Dernière mise à jour : août 2026</p>
      </div>
    </div>
  );
}